import { render, staticRenderFns } from "./RegisterSongs.vue?vue&type=template&id=25bf4e7f&scoped=true"
import script from "./RegisterSongs.vue?vue&type=script&lang=ts"
export * from "./RegisterSongs.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSongs.vue?vue&type=style&index=0&id=25bf4e7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bf4e7f",
  null
  
)

export default component.exports